import { apiConstants } from '../../apiConstant'
import { formDataCommonFunction, formDataCommonFunctionPut, serviceCall } from '../../serviceCall'

const updateServiceRequestoptionApi = (data, callback, errorCallBack, params) => {

  return async (dispatch) => {

    formDataCommonFunctionPut(data, apiConstants.USER.UPDATE_SERVICE_REQUEST_OPTION)
      .then((response) => {
        callback && callback(response)
      })
      .catch((error) => {
        errorCallBack && errorCallBack(error.response)
      })
  }
}

export default updateServiceRequestoptionApi;
